import React from "react";
import profileImage from "../../../assets/imgs/dummy-img.png";
import "../passenger.css";
import { Avatar } from "primereact/avatar";
import { Rating } from "primereact/rating";
import { Timeline } from "primereact/timeline";
import moment from "moment";

const ScheduleRide = (data) => {
    if (!data?.data || data?.data?.length === 0) {
        return (
            <div className="surface-card p-4 md:m-2 text-center">
                <p className="text-lg font-semibold">No routes found!</p>
            </div>
        );
    }
    return (
        <section className="grid">
            {data?.data?.map((route, index) => (
                <div className="col-12 sm:col-6 xl:col-4">
                    <div key={index} className="surface-card p-4 md:m-2">
                        <div className="flex align-items-center justify-content-between">
                            <div className="flex align-items-center cursor-pointer">
                                <div>
                                    <p className="mb-1 text-lg font-semibold" style={{ textTransform: "capitalize" }}>
                                        {route?.userId?.firstName + " " + route?.userId?.lastName || "Driver Name"}
                                    </p>
                                    <Rating value={route.rating || 0} readOnly cancel={false} />
                                </div>
                            </div>
                        </div>
                        <hr />

                        <div className="flex my-4">
                            <div>
                                <Timeline
                                    value={[
                                        { status: route.startPoint.placeName ? route?.startPoint?.placeName : "Not found", icon: "pi pi-map-marker" },
                                        { status: route?.endPoint?.placeName ? route?.endPoint?.placeName : "Not found", icon: "pi pi-flag" },
                                    ]}
                                    align="left"
                                    className="custom-timeline"
                                    marker={(item) => (
                                        <span className={`p-timeline-event-icon p-pt-2 text-white`}>
                                            <i className={item?.icon} style={{ fontSize: "1.5rem" }}></i>
                                        </span>
                                    )}
                                    content={(item) => (
                                        <div className="flex flex-column">
                                            <span>{item?.status}</span>
                                        </div>
                                    )}
                                />
                            </div>
                        </div>
                        <div className="flex align-items-center justify-content-between flex-wrap ml-2">
                            <h6 className="my-1">Date & Time</h6>
                            <div className="flex align-items-center">
                                <span className="font-semibold"> {moment(route?.date).format("Do MMM, YYYY hh:mm A")}</span>
                            </div>
                        </div>
                    </div>
                </div>
            ))}
        </section>
    );
};

export default ScheduleRide;
